<template>
  <div
    v-if="layoutSlot && layoutSlot.activity"
    style="border-radius: 4px;"
    class="poster-wrapper text-left activity"
    :class="{
      planned: layoutSlot.planned,
      preview: layoutSlot.preview,
      'p-sm': size === 'sm'
    }"
    :style="'color: ' + color + '; border-color: ' + color + '; background-color: ' + color + '33;'"
  >
    <q-img
      basic
      class="q-ma-none"
      :class="{ 'img-preview': layoutSlot.preview }"
      :src="layoutSlot.activity.posterImageSmallUrl"
    />
    <div
      class="q-px-sm q-py-xs"
      style="z-index: 5"
    >
      {{ layoutSlot.activity.name[0] }}
    </div>
    <q-tooltip>
      <div class="text-h6">
        {{ layoutSlot.activity.name }}
      </div>
    </q-tooltip>
  </div>
</template>

<script>
export default {
  name: 'LayoutSlot',
  props: {
    layoutSlot: {
      type: Object,
      required: false,
      default: null
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    }
  },
  computed: {
    color () {
      return this.layoutSlot.activity?.color
    }
  }
}

</script>

<style lang="scss" scoped>
  .preview {
    border: dotted 2px !important;
    opacity: 0.5 !important;
    pointer-events: none;
  }

  .activity {
    border: solid 2px;
    opacity: 1;
  }

  .planned {
    border: dashed 2px;
    opacity: 0.75;
  }

  .poster-wrapper {
    width: 49px;
    height: 69px;
    overflow: hidden;
  }

  .poster-wrapper.p-sm {
    width: 29px;
    height: 40px;
  }
</style>
